import React, { useEffect, useState } from "react";
import { getCustomers, saveCustomer, searchCustomers, bulkImportCustomers, exportCustomersToExcel } from "../../components/Api/GmsCustomer";
import { ClipLoader } from "react-spinners";
import { getBranches } from "../../components/Api/GmsBranch";
import { getCountries } from "../../components/Api/GmsCountry";
import { getBusinesses } from "../../components/Api/GmsBusiness";
import Swal from "sweetalert2";
import API_URL from '../../config';
import { Card, CardBody, CardTitle, Col, Container, Form, FormGroup, Input, Label, Row, Button, Table } from "reactstrap";
import Select from "react-select";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import 'bootstrap/dist/css/bootstrap.min.css';
import {
  hasPagePermissionWithAdmin,
  hasViewOnlyPermission,
  hasEditOrHigherPermission,
  hasDeletePermissionWithAdmin,
  isUserAdmin
} from "../../components/Permission/PermissionService";
import * as XLSX from 'xlsx';
import { Download, Mail, Phone, Calendar, MapPin, CreditCard, User, Building2, FileText, X, Info } from "lucide-react";
import CustomerProfileModal from "../../components/CustomerProfileModal";
import '../../assets/css/customer-theme.css';

const getDefaultForm = () => {
  // Get user's branch ID from localStorage if available
  const userBranchId = localStorage.getItem("userBranchId");

  return {
    customer_Id: null,
    customer_Code: "",
    customer_NameEn: "",
    customer_NameAr: "",
    customer_IsInternational: false,
    customer_AddressEn: "",
    customer_AddressAr: "",
    customer_Email: "",
    customer_ContactNo: "",
    customer_RepDetails: "",
    customer_Notes: "",
    customer_Active: true,
    customer_Business_Id: localStorage.getItem("userCompanyId") ? Number(localStorage.getItem("userCompanyId")) : null,
    customer_Branch_Id: userBranchId ? Number(userBranchId) : null,
    customer_CreditLimit: 0,
    customer_CreatedDate: new Date(),
    customer_CreatedBy: Number(localStorage.getItem("userId")) || 1,
    customer_ModifiedDate: new Date(),
    customer_ModifiedBy: Number(localStorage.getItem("userId")) || 1,
    customer_Type: 1, // 1 = Individual, 2 = Business
    company_Name: "",
    primaryContact_Name: "",
    primaryContact_Phone: "",
    customer_ID_Number: "", // New field for National ID or Business ID
    customer_DOB: "", // New field for Date of Birth
    customer_Salutation: "", // New field for Salutation
    customer_TRN: "", // New field for TRN
    customer_Country_Id: null, // New field for Country ID
    initialPoints: 0,
    pointsBalance: 0,
  };
};

const defaultValidation = {
  customer_NameEn: "",
  customer_NameAr: "",
  customer_AddressEn: "",
  customer_AddressAr: "",
  customer_Email: "",
  customer_ContactNo: "",
  customer_Business_Id: "",
  customer_Branch_Id: "",
  customer_CreditLimit: "",
  company_Name: "",
  primaryContact_Name: "",
  primaryContact_Phone: "",
  customer_ID_Number: "",
  customer_DOB: "",
  customer_Salutation: "",
  customer_TRN: "",
  customer_Country_Id: "",
  initialPoints: "",
  pointsBalance: "",
};

const emptyFilter = {
  customer_Id: null,
  customer_Code: null,
  customer_NameEn: null,
  customer_NameAr: null,
  customer_IsInternational: null,
  customer_AddressEn: null,
  customer_AddressAr: null,
  customer_Email: null,
  customer_ContactNo: null,
  customer_RepDetails: null,
  customer_Notes: null,
  customer_Active: null,
  customer_Business_Id: null,
  customer_Branch_Id: null,
  customer_CreditLimit: null,
  customer_CreatedDate: null,
  customer_CreatedBy: null,
  customer_ModifiedDate: null,
  customer_ModifiedBy: null,
  customer_Type: null,
  company_Name: null,
  customer_ID_Number: null,
  customer_DOB: null,
};

const FormSelect = ({ label, id, name, options, value, onChange, error, required = true, disabled = false, icon: Icon }) => (
  <div className="form-group mb-2">
    <Label className="col-form-label pb-0" htmlFor={id} style={{ fontSize: '12px', fontWeight: '600', color: '#495057', marginBottom: '2px' }}>
      {label} {required && <span style={{ color: '#dc3545' }}>*</span>}
    </Label>
    <div style={{ position: 'relative' }}>
      {Icon && (
        <div style={{
          position: 'absolute',
          left: '12px',
          top: '50%',
          transform: 'translateY(-50%)',
          zIndex: 2,
          color: '#6c757d',
          pointerEvents: 'none'
        }}>
          <Icon size={18} />
        </div>
      )}
      <Select
        id={id}
        name={name}
        options={options}
        filterOption={() => true}
        value={value}
        onChange={onChange}
        isClearable={!required}
        isSearchable
        placeholder={`Select ${label}`}
        classNamePrefix="select2-selection"
        className={error ? 'is-invalid' : ''}
        isDisabled={disabled}
        styles={{
          control: (provided, state) => ({
            ...provided,
            backgroundColor: disabled ? '#f8f9fa' : '#fff',
            borderColor: error ? '#dc3545' : (state.isFocused ? '#556ee6' : '#ced4da'),
            boxShadow: state.isFocused && !error ? '0 0 0 0.2rem rgba(85, 110, 230, 0.25)' : 'none',
            minHeight: '35px',
            borderRadius: '5px',
            fontSize: '13px',
            paddingLeft: Icon ? '40px' : '8px',
            '&:hover': {
              borderColor: error ? '#dc3545' : '#556ee6'
            }
          }),
          menu: (provided) => ({
            ...provided,
            borderRadius: '6px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            zIndex: 9999
          }),
          option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected ? '#556ee6' : state.isFocused ? '#f8f9fa' : 'white',
            color: state.isSelected ? 'white' : '#495057',
            fontSize: '13px',
            padding: '8px 12px',
            '&:hover': {
              backgroundColor: state.isSelected ? '#556ee6' : '#e9ecef'
            }
          }),
          placeholder: (provided) => ({
            ...provided,
            color: '#6c757d',
            fontSize: '13px'
          }),
          singleValue: (provided) => ({
            ...provided,
            color: '#495057',
            fontSize: '13px'
          })
        }}
      />
    </div>
    {error && (
      <div className="invalid-feedback d-block" style={{ fontSize: '12px', marginTop: '4px' }}>
        {error}
      </div>
    )}
  </div>
);

const FormInput = ({ label, id, name, type = "text", value, onChange, error, required = true, placeholder, disabled = false, icon: Icon }) => (
  <div className="form-group mb-2">
    <Label className="col-form-label pb-0" htmlFor={id} style={{ fontSize: '12px', fontWeight: '600', color: '#495057', marginBottom: '2px' }}>
      {label} {required && <span style={{ color: '#dc3545' }}>*</span>}
    </Label>
    <div style={{ position: 'relative' }}>
      {Icon && (
        <div style={{
          position: 'absolute',
          left: '12px',
          top: '50%',
          transform: 'translateY(-50%)',
          zIndex: 1,
          color: '#6c757d',
          display: 'flex',
          alignItems: 'center'
        }}>
          <Icon size={18} />
        </div>
      )}
      <Input
        type={type}
        className={`form-control ${error ? 'is-invalid' : ''}`}
        id={id}
        name={name}
        value={value || ''}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        style={{
          paddingLeft: Icon ? '40px' : '12px',
          borderRadius: '5px',
          border: error ? '1px solid #dc3545' : '1px solid #ced4da',
          fontSize: '13px',
          height: '35px',
          transition: 'all 0.2s ease',
          backgroundColor: disabled ? '#f8f9fa' : '#fff'
        }}
        onFocus={(e) => {
          if (!error) e.target.style.borderColor = '#556ee6';
        }}
        onBlur={(e) => {
          if (!error) e.target.style.borderColor = '#ced4da';
        }}
      />
    </div>
    {error && (
      <div className="invalid-feedback d-block" style={{ fontSize: '12px', marginTop: '4px' }}>
        {error}
      </div>
    )}
  </div>
);

const FormCheckbox = ({ label, id, name, checked, onChange, disabled = false }) => (
  <div className="form-group">
    <div className="form-check form-switch">
      <input
        type="checkbox"
        className="form-check-input"
        id={id}
        name={name}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
      <label className="form-check-label" htmlFor={id} style={{ fontSize: '13px', fontWeight: '500', cursor: 'pointer' }}>
        {label === "Active" ? (checked ? "Active" : "Inactive") : label}
      </label>
    </div>
  </div>
);

const FormTextarea = ({ label, id, name, value, onChange, error, required = true, placeholder, rows = 3, icon: Icon }) => (
  <div className="form-group mb-2">
    <Label className="col-form-label pb-0" htmlFor={id} style={{ fontSize: '12px', fontWeight: '600', color: '#495057', marginBottom: '2px' }}>
      {label} {required && <span style={{ color: '#dc3545' }}>*</span>}
    </Label>
    <div style={{ position: 'relative' }}>
      {Icon && (
        <div style={{
          position: 'absolute',
          left: '12px',
          top: '14px',
          zIndex: 1,
          color: '#6c757d'
        }}>
          <Icon size={18} />
        </div>
      )}
      <Input
        type="textarea"
        className={`form-control ${error ? 'is-invalid' : ''}`}
        id={id}
        name={name}
        value={value || ''}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        rows={rows}
        style={{
          paddingLeft: Icon ? '40px' : '12px',
          borderRadius: '5px',
          border: error ? '1px solid #dc3545' : '1px solid #ced4da',
          fontSize: '13px',
          transition: 'all 0.2s ease',
          backgroundColor: '#fff',
          resize: 'vertical'
        }}
        onFocus={(e) => {
          if (!error) e.target.style.borderColor = '#556ee6';
        }}
        onBlur={(e) => {
          if (!error) e.target.style.borderColor = '#ced4da';
        }}
      />
    </div>
    {error && (
      <div className="invalid-feedback d-block" style={{ fontSize: '12px', marginTop: '4px' }}>
        {error}
      </div>
    )}
  </div>
);

const FormRadio = ({ label, name, options, value, onChange, error, required = true }) => (
  <div className="form-group mb-2">
    <Label className="col-form-label pb-0" style={{ fontSize: '12px', fontWeight: '600', color: '#495057', marginBottom: '2px', display: 'block' }}>
      {label} {required && <span style={{ color: '#dc3545' }}>*</span>}
    </Label>
    <div style={{ display: 'flex', gap: '20px', marginTop: '4px' }}>
      {options.map((option) => (
        <div key={option.value} style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
          <Input
            type="radio"
            className="form-check-input"
            id={`${name}_${option.value}`}
            name={name}
            value={option.value}
            checked={value === option.value}
            onChange={onChange}
            style={{
              width: '18px',
              height: '18px',
              cursor: 'pointer',
              accentColor: '#556ee6'
            }}
          />
          <Label className="form-check-label" htmlFor={`${name}_${option.value}`} style={{
            margin: 0,
            cursor: 'pointer',
            fontSize: '13px',
            color: '#495057',
            fontWeight: value === option.value ? '600' : '400'
          }}>
            {option.label}
          </Label>
        </div>
      ))}
    </div>
    {error && (
      <div className="invalid-feedback d-block" style={{ fontSize: '12px', marginTop: '4px' }}>
        {error}
      </div>
    )}
  </div>
);

export default function CustomerPage() {
  const [customers, setCustomers] = useState([]);
  const [branches, setBranches] = useState([]);
  const [businesses, setBusinesses] = useState([]);
  const [countries, setCountries] = useState([]);
  const [form, setForm] = useState(getDefaultForm());
  const [filter, setFilter] = useState(emptyFilter);
  const [isEditing, setIsEditing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [viewLoadingRow, setViewLoadingRow] = useState(null);
  const [editLoadingRow, setEditLoadingRow] = useState(null);

  // Check permissions
  const permissions = JSON.parse(localStorage.getItem('permissions') || '[]');
  const hasPermission = hasPagePermissionWithAdmin(permissions, '/GmsCustomer');
  const isViewOnly = hasViewOnlyPermission(permissions, '/GmsCustomer');
  const hasEditOrHigher = hasEditOrHigherPermission(permissions, '/GmsCustomer');
  const hasDeletePermission = hasDeletePermissionWithAdmin(permissions, '/GmsCustomer');
  const isAdmin = isUserAdmin();
  const [branchOptions, setBranchOptions] = useState([]);
  const [businessOptions, setBusinessOptions] = useState([]);
  const [branchLoading, setBranchLoading] = useState(false);
  const [businessLoading, setBusinessLoading] = useState(false);
  const [profileModalOpen, setProfileModalOpen] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [validationErrors, setValidationErrors] = useState(defaultValidation);
  const [customerNameOptions, setCustomerNameOptions] = useState([]);
  const [customerSearchOptions, setCustomerSearchOptions] = useState([]);
  const [customerSearchLoading, setCustomerSearchLoading] = useState(false);
  const [searchTimeout, setSearchTimeout] = useState(null);

  // Excel upload states
  const [excelFile, setExcelFile] = useState(null);
  const [parsedData, setParsedData] = useState([]);
  const [importLoading, setImportLoading] = useState(false);
  const [importProgress, setImportProgress] = useState({ current: 0, total: 0 });
  const [showExcelImport, setShowExcelImport] = useState(false);

  const formatDateTime = (dateTimeStr) => {
    try {
      return dateTimeStr.split('T')[0];
    } catch (error) {
      return "N/A";
    }
  };

  const formatFullDateTime = (dateTimeStr) => {
    try {
      const date = new Date(dateTimeStr);
      return date.toLocaleString();
    } catch (error) {
      return "N/A";
    }
  };

  useEffect(() => {
    if (hasPermission) {
      loadBusinesses();
      loadBranches();
      loadCountries();
      // Check if we need to load a specific customer for editing
      const urlParams = new URLSearchParams(window.location.search);
      const editId = urlParams.get('edit');
      if (editId) {
        setIsEditing(true);
        setLoading(true);
        // Optimize: Fetch ONLY the specific customer being edited instead of all customers
        getCustomers({ customer_Id: parseInt(editId) }).then((customersData) => {
          if (customersData && customersData.length > 0) {
            handleEdit(customersData[0]);
          } else {
            console.error("Customer not found for ID:", editId);
            setIsEditing(false);
          }
        }).catch(error => {
          console.error("Error loading customer for edit:", error);
          Swal.fire("Error", "Failed to load customer details", "error");
          setIsEditing(false);
        }).finally(() => {
          setLoading(false);
        });
      }
    }
  }, [hasPermission]);

  // Mark body while Customer page is active (used for scoped topbar color overrides)
  useEffect(() => {
    document.body.classList.add("customer-page-active");
    return () => {
      document.body.classList.remove("customer-page-active");
    };
  }, []);

  const loadCountries = async () => {
    try {
      const countriesData = await getCountries();
      setCountries(countriesData || []);
    } catch (error) {
      console.error("Error loading countries:", error);
      setCountries([]);
    }
  };

  const loadBusinesses = async () => {
    try {
      setBusinessLoading(true);
      const businessesData = await getBusinesses({ business_Active: true });
      const options = (businessesData || []).map(biz => ({
        value: biz.business_Id,
        label: biz.business_NameEn
      }));
      setBusinessOptions(options);
      setBusinesses(businessesData || []);
    } catch (error) {
      console.error("Error loading businesses:", error);
      Swal.fire("Error", "Failed to load businesses", "error");
    } finally {
      setBusinessLoading(false);
    }
  };

  const loadBranches = async () => {
    try {
      setBranchLoading(true);
      const branchesData = await getBranches({ branch_Active: true });
      const options = branchesData.map(branch => ({
        value: branch.branch_Id,
        label: branch.branch_NameEn
      }));
      setBranchOptions(options);
      setBranches(branchesData);
    } catch (error) {
      console.error("Error loading branches:", error);
      Swal.fire("Error", "Failed to load branches", "error");
    } finally {
      setBranchLoading(false);
    }
  };

  const loadCustomers = async () => {
    try {
      const customersData = await getCustomers({});
      setCustomers(customersData);

      // Generate customer name options for dropdown
      const uniqueCustomerNames = [...new Set(customersData.map(customer => customer.customer_NameEn).filter(Boolean))];
      const nameOptions = uniqueCustomerNames.map(name => ({
        value: name,
        label: name
      }));
      setCustomerNameOptions(nameOptions);

      return customersData;
    } catch (error) {
      console.error("Error loading customers:", error);
      Swal.fire("Error", "Failed to load customers", "error");
      return [];
    }
  };

  // Manual search function for customer name search
  const searchCustomerNamesManually = async (inputValue) => {
    console.log('ðŸ” searchCustomerNamesManually called with inputValue:', inputValue);

    if (!inputValue || inputValue.length < 3) {
      console.log('âŒ Input too short, clearing options');
      setCustomerSearchOptions([]);
      return;
    }

    try {
      setCustomerSearchLoading(true);
      const cleanedInput = inputValue.replace(/\s+/g, '');
      console.log('ðŸš€ Making API call to searchCustomers with:', { cleanedInput, page: 1, pageSize: 20 });
      const response = await searchCustomers(cleanedInput, 1, 20);
      console.log('âœ… API response received:', response);

      const formattedOptions = response.items.map(customer => ({
        value: customer.customer_NameEn,
        label: `${customer.customer_NameEn || 'N/A'} â€” ${customer.customer_ContactNo || 'N/A'}`,
        customer: customer
      }));

      console.log('ðŸ“‹ Formatted options:', formattedOptions);
      setCustomerSearchOptions(formattedOptions);
    } catch (error) {
      console.error('âŒ Error searching customers:', error);
      setCustomerSearchOptions([]);
    } finally {
      setCustomerSearchLoading(false);
    }
  };

  const validateEmail = (email) => {
    if (!email || email.trim() === "") return "";
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email.trim()) ? "" : "Please enter a valid email address.";
  };

  const validateContactNumber = (contactNo) => {
    if (!contactNo || contactNo.trim() === "") return "";
    const phoneRegex = /^\d+$/;
    return phoneRegex.test(contactNo.trim()) ? "" : "Contact number can only contain numbers.";
  };

  // Excel upload functions
  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    if (!file.name.match(/\.(xlsx|xls)$/)) {
      Swal.fire("Error", "Please select an Excel file (.xlsx or .xls)", "error");
      return;
    }

    setExcelFile(file);
    parseExcelFile(file);
  };

  const parseExcelFile = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet);

        if (jsonData.length === 0) {
          Swal.fire("Error", "No data found in the Excel file", "error");
          return;
        }

        // Map Excel data to customer format
        const mappedData = jsonData.map((row, index) => {
          // Combine First Name + Last Name for customer name
          const firstName = row['First Name'] || '';
          const lastName = row['Last Name'] || '';
          const fullName = `${firstName} ${lastName}`.trim();

          // Get phone from Phone or MobilePhone column - convert to string
          const phone = row['Phone'] || row['MobilePhone'] || '';
          const phoneString = phone ? String(phone).trim() : '';

          // Get salutation
          const salutation = row['Salutation'] || '';

          return {
            customer_Id: null,
            customer_Code: "",
            customer_NameEn: fullName,
            customer_NameAr: "",
            customer_IsInternational: false,
            customer_AddressEn: "",
            customer_AddressAr: "",
            customer_Email: "",
            customer_ContactNo: phoneString,
            customer_RepDetails: "",
            customer_Notes: "",
            customer_Active: true,
            customer_Branch_Id: null,
            customer_CreditLimit: 0,
            customer_Type: 1, // Individual
            company_Name: "",
            primaryContact_Name: "",
            primaryContact_Phone: "",
            customer_ID_Number: "",
            customer_DOB: null,
            customer_Salutation: salutation,
            customer_CreatedDate: new Date(),
            customer_CreatedBy: Number(localStorage.getItem("userId")) || 1,
            customer_ModifiedDate: new Date(),
            customer_ModifiedBy: Number(localStorage.getItem("userId")) || 1,
            _rowIndex: index + 1 // For error tracking
          };
        }).filter(customer => customer.customer_NameEn && customer.customer_ContactNo && customer.customer_ContactNo.trim() !== '');

        setParsedData(mappedData);
        Swal.fire("Success", `Parsed ${mappedData.length} customers from Excel file`, "success");
      } catch (error) {
        console.error("Error parsing Excel file:", error);
        Swal.fire("Error", "Failed to parse Excel file. Please check the format.", "error");
      }
    };
    reader.readAsArrayBuffer(file);
  };

  const handleBulkImport = async () => {
    if (parsedData.length === 0) {
      Swal.fire("Error", "No data to import", "error");
      return;
    }

    const result = await Swal.fire({
      title: 'Confirm Import',
      text: `Are you sure you want to import ${parsedData.length} customers?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes, Import',
      cancelButtonText: 'Cancel'
    });

    if (!result.isConfirmed) return;

    try {
      setImportLoading(true);
      setImportProgress({ current: 0, total: parsedData.length });

      // Clean up data before sending - remove null/0 fields that backend cannot accept
      const cleanedData = parsedData.map(item => {
        const cleaned = { ...item };

        // Remove customer_Id if it's null (backend can accept null for int?, but let's be safe)
        if (cleaned.customer_Id === null || cleaned.customer_Id === undefined) {
          delete cleaned.customer_Id;
        }

        // Ensure customer_ContactNo is a string (not number)
        if (cleaned.customer_ContactNo !== null && cleaned.customer_ContactNo !== undefined) {
          cleaned.customer_ContactNo = String(cleaned.customer_ContactNo);
        }

        // Remove _rowIndex as it's not part of the model
        if (cleaned._rowIndex !== undefined) {
          delete cleaned._rowIndex;
        }

        return cleaned;
      });

      const response = await bulkImportCustomers(cleanedData);

      setImportLoading(false);
      setImportProgress({ current: 0, total: 0 });

      // Handle response - check isSuccess flag
      if (response && (response.isSuccess === true || response.isSuccess === undefined)) {
        // Show detailed import results including duplicates
        const message = response.message || `Successfully imported customers!`;
        const importedCount = response.ids ? (response.ids.split(',').filter(id => id && id.trim() !== '').length) : 0;
        const skippedCount = parsedData.length - importedCount;

        if (skippedCount > 0 || message.includes('skipped')) {
          Swal.fire({
            title: "Import Completed",
            html: `<div style="text-align: left;">
              <p><strong>${importedCount}</strong> customer(s) imported successfully.</p>
              <p><strong>${skippedCount}</strong> record(s) skipped (duplicates or missing required fields).</p>
              ${message.includes('Details:') ? `<p style="font-size: 12px; margin-top: 10px; color: #666;">${message}</p>` : ''}
            </div>`,
            icon: importedCount > 0 ? "warning" : "error",
            confirmButtonText: "OK",
            width: '600px'
          });
        } else {
          Swal.fire("Success", message, "success");
        }

        // Clear parsed data only if some records were imported
        if (importedCount > 0) {
          setParsedData([]);
          setExcelFile(null);
        }
      } else {
        // Show error message with details
        const errorMessage = response?.message || "Import failed. Please check for duplicates or missing required fields.";
        Swal.fire({
          title: "Import Failed",
          text: errorMessage,
          icon: "error",
          confirmButtonText: "OK",
          width: '600px'
        });
      }
    } catch (error) {
      console.error("Bulk import error:", error);
      setImportLoading(false);
      setImportProgress({ current: 0, total: 0 });

      // Extract detailed error message
      const errorMessage = error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.message ||
        "Failed to import customers. Please check for duplicates or missing required fields.";
      Swal.fire({
        title: "Import Error",
        text: errorMessage,
        icon: "error",
        confirmButtonText: "OK",
        width: '600px'
      });
    }
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    const newValue = type === 'checkbox' ? checked : (type === 'radio' ? parseInt(value) : value);

    setForm(prev => {
      const updatedForm = {
        ...prev,
        [name]: newValue
      };

      // If customer type changes to Individual, clear company name
      if (name === 'customer_Type' && newValue === 1) {
        updatedForm.company_Name = "";
      }

      // If customer type changes to Business, clear DOB
      if (name === 'customer_Type' && newValue === 2) {
        updatedForm.customer_DOB = "";
      }

      // Keep pointsBalance in sync with initialPoints automatically
      if (name === 'initialPoints') {
        updatedForm.pointsBalance = newValue;
      }

      return updatedForm;
    });

    // Clear validation error for this field
    setValidationErrors(prev => ({
      ...prev,
      [name]: ""
    }));

    // Real-time validation for email and contact number
    if (name === 'customer_Email') {
      const emailError = validateEmail(value);
      setValidationErrors(prev => ({
        ...prev,
        customer_Email: emailError
      }));
    }

    if (name === 'customer_ContactNo') {
      const contactError = validateContactNumber(value);
      setValidationErrors(prev => ({
        ...prev,
        customer_ContactNo: contactError
      }));
    }
  };

  const handleSelectChange = (name, selectedOption) => {
    const value = selectedOption ? selectedOption.value : null;
    setForm(prev => ({
      ...prev,
      [name]: value
    }));

    // If Business changes, reload branches and clear branch selection
    if (name === 'customer_Business_Id') {
      setForm(prev => ({ ...prev, customer_Branch_Id: null }));
    }

    // Clear validation error for this field
    setValidationErrors(prev => ({
      ...prev,
      [name]: ""
    }));
  };

  const handleFilterChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFilter(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : (value === '' ? null : value)
    }));
  };

  const handleFilterSelectChange = (name, selectedOption) => {
    setFilter(prev => ({
      ...prev,
      [name]: selectedOption ? selectedOption.value : null
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let hasErrors = false;
    const newValidationErrors = { ...defaultValidation };

    // Required field validations - Customer Name (English), Contact Number, and Country are mandatory
    if (!form.customer_NameEn || form.customer_NameEn.trim() === "") {
      newValidationErrors.customer_NameEn = "Customer Name (English) is required.";
      hasErrors = true;
    }
    if (!form.customer_ContactNo || form.customer_ContactNo.trim() === "") {
      newValidationErrors.customer_ContactNo = "Contact Number is required.";
      hasErrors = true;
    }
    if (!form.customer_Country_Id || form.customer_Country_Id === null) {
      newValidationErrors.customer_Country_Id = "Country is required.";
      hasErrors = true;
    }
    if (!form.customer_Business_Id || form.customer_Business_Id === null) {
      newValidationErrors.customer_Business_Id = "Company is required.";
      hasErrors = true;
    }
    if (!form.customer_Branch_Id || form.customer_Branch_Id === null) {
      newValidationErrors.customer_Branch_Id = "Branch is required.";
      hasErrors = true;
    }

    // Email validation (if provided)
    if (form.customer_Email && form.customer_Email.trim() !== "") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(form.customer_Email.trim())) {
        newValidationErrors.customer_Email = "Please enter a valid email address.";
        hasErrors = true;
      }
    }

    // Contact number validation (if provided)
    if (form.customer_ContactNo && form.customer_ContactNo.trim() !== "") {
      const phoneRegex = /^\d+$/;
      if (!phoneRegex.test(form.customer_ContactNo.trim())) {
        newValidationErrors.customer_ContactNo = "Contact number can only contain numbers.";
        hasErrors = true;
      }
    }

    setValidationErrors(newValidationErrors);

    if (hasErrors) {
      Swal.fire("Validation Error", "Please Enter All The Details.", "warning");
      return;
    }

    try {
      setLoading(true);

      const customerData = {
        ...form,
        customer_DOB: form.customer_DOB === "" ? null : form.customer_DOB,
        customer_CreatedBy: Number(localStorage.getItem("userId")) || 1,
        customer_ModifiedBy: Number(localStorage.getItem("userId")) || 1,
      };

      // Ensure active=true by default for users without delete permission
      if (!hasDeletePermission) {
        customerData.customer_Active = true;
      }

      console.log("Saving customer data:", customerData);
      const response = await saveCustomer(customerData);
      console.log("API response:", response);

      // Check if response has id (success) or error message
      if (response && response.id && response.id > 0) {
        Swal.fire("Success", response.message || "Customer saved successfully", "success");
        resetForm();
      } else {
        // Handle duplicate validation error or other errors
        // When API returns id: -1, it means validation failed but request was successful
        const errorMessage = response?.message || "Failed to save customer. Please check the details and try again.";
        Swal.fire({
          title: "Error",
          text: errorMessage,
          icon: "error",
          confirmButtonText: "OK"
        });
      }
    } catch (error) {
      console.error("Error saving customer:", error);
      // Extract error message from API response
      // If it's a BadRequest (400), the message is in response.data.message
      // If it's a server error (500), handle differently
      let errorMessage = "Failed to save customer.";

      if (error?.response?.status === 400) {
        // BadRequest - duplicate validation or other validation error
        errorMessage = error?.response?.data?.message ||
          "A customer with the same name and mobile number already exists. Please use a different name or mobile number.";
      } else if (error?.response?.status === 500) {
        // Server error
        errorMessage = error?.response?.data?.message ||
          error?.response?.data ||
          "An error occurred while saving the customer. Please try again.";
      } else if (error?.response?.data) {
        // Any other error with response data
        errorMessage = error?.response?.data?.message ||
          error?.response?.data ||
          "Failed to save customer. Please try again.";
      } else {
        // Network error or other
        errorMessage = error?.message ||
          "Failed to save customer. Please check your connection and try again.";
      }

      Swal.fire({
        title: "Error",
        text: errorMessage,
        icon: "error",
        confirmButtonText: "OK"
      });
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    // Reset form to default values
    setForm(getDefaultForm());
    setIsEditing(false);
    setValidationErrors(defaultValidation);
    // Scroll to top of form
    window.scrollTo(0, 0);
  };

  const handleEdit = (customer) => {
    const userCompanyId = localStorage.getItem("userCompanyId");
    setForm({
      ...customer,
      customer_Branch_Id: customer.customer_Branch_Id,
      customer_Business_Id: customer.customer_Business_Id || (userCompanyId ? Number(userCompanyId) : null),
      customer_Country_Id: customer.customer_Country_Id
    });
    setIsEditing(true);
    setValidationErrors(defaultValidation);
    window.scrollTo(0, 0);
  };

  const handleView = (customer) => {
    setSelectedCustomer(customer);
    setProfileModalOpen(true);
  };

  const handleExportExcel = async () => {
    try {
      setLoading(true);
      // Clean filter - remove empty strings and convert to proper format
      const cleanFilter = {
        ...(filter.customer_Id !== null && filter.customer_Id !== undefined && { customer_Id: filter.customer_Id }),
        ...(filter.customer_NameEn && filter.customer_NameEn.trim() !== '' && { customer_NameEn: filter.customer_NameEn }),
        ...(filter.customer_ContactNo && filter.customer_ContactNo.trim() !== '' && { customer_ContactNo: filter.customer_ContactNo }),
        ...(filter.customer_IsInternational !== null && filter.customer_IsInternational !== undefined && { customer_IsInternational: filter.customer_IsInternational }),
        ...(filter.customer_Active !== null && filter.customer_Active !== undefined && { customer_Active: filter.customer_Active }),
        ...(filter.customer_Business_Id !== null && filter.customer_Business_Id !== undefined && { customer_Business_Id: filter.customer_Business_Id }),
        ...(filter.customer_Branch_Id !== null && filter.customer_Branch_Id !== undefined && { customer_Branch_Id: filter.customer_Branch_Id }),
        ...(filter.company_Name && filter.company_Name.trim() !== '' && { company_Name: filter.company_Name })
      };

      await exportCustomersToExcel(cleanFilter);
      Swal.fire("Success", "Customer report exported successfully", "success");
    } catch (error) {
      console.error("Error exporting customers:", error);
      Swal.fire("Error", "Failed to export customer report", "error");
    } finally {
      setLoading(false);
    }
  };

  const getBranchName = (branchId) => {
    const branch = branches.find(b => b.branch_Id === branchId);
    return branch ? branch.branch_NameEn : 'N/A';
  };

  return (
    <React.Fragment>
      <div className="page-content customer-page">
        <Container fluid style={{ paddingTop: '0', paddingBottom: '0' }}>
          <Breadcrumbs title="Customer Management" breadcrumbItem="Spa" />
          <Row style={{ marginTop: '2px', marginBottom: '0' }}>
            <Col lg={12} style={{ paddingTop: '0' }}>
              <Card style={{ marginTop: '0' }}>
                <CardBody style={{ paddingTop: '12px', paddingBottom: '12px' }}>
                  <div className="customer-form-container" style={{
                    padding: '16px',
                    borderRadius: '8px',
                    minHeight: '100%',
                    position: 'relative'
                  }}>
                    {loading && (
                      <div style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(255, 255, 255, 0.7)',
                        zIndex: 1000,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        borderRadius: '8px'
                      }}>
                        <ClipLoader size={50} color="#556ee6" />
                        <p style={{ marginTop: '15px', fontWeight: '500', color: '#556ee6' }}>Loading customer details...</p>
                      </div>
                    )}
                    <Form id="customerForm" onSubmit={handleSubmit}>
                      {/* Header Section */}
                      <div className="d-flex justify-content-between align-items-center mb-4 pb-3 border-bottom">
                        <div className="d-flex align-items-center gap-2">
                          <h4 className="mb-0 text-dark" style={{ fontSize: '18px', fontWeight: '700' }}>
                            {isEditing ? (
                              <><span className="text-primary">Edit</span> Profile {form.customer_Code && <small className="text-muted ms-2" style={{ fontSize: '13px' }}>({form.customer_Code})</small>}</>
                            ) : "Add New Customer"}
                          </h4>
                          {!isViewOnly && (
                            <Button
                              type="button"
                              color="info"
                              size="sm"
                              className="ms-2 px-2 py-1"
                              onClick={() => {
                                setShowExcelImport(!showExcelImport);
                                if (!showExcelImport) {
                                  setTimeout(() => {
                                    const excelSection = document.getElementById('excelImportSection');
                                    if (excelSection) {
                                      excelSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
                                    }
                                  }, 100);
                                }
                              }}
                              style={{ borderRadius: '4px', fontSize: '12px', fontWeight: '600' }}
                            >
                              <Download className="me-1" size={13} />
                              Import Excel
                            </Button>
                          )}
                        </div>
                        <div className="d-flex gap-2">
                          <Button
                            type="button"
                            outline
                            color="secondary"
                            onClick={resetForm}
                            className="px-3 py-1"
                            style={{ borderRadius: '6px', fontSize: '13px', fontWeight: '500' }}
                            disabled={isViewOnly || loading}
                          >
                            Cancel
                          </Button>
                          <Button
                            type="submit"
                            color="success"
                            disabled={loading || isViewOnly}
                            className="save-profile-button px-3 py-1"
                            style={{ borderRadius: '6px', fontSize: '13px', fontWeight: '600', minWidth: '120px' }}
                          >
                            {loading ? (
                              <><ClipLoader size={11} color="#fff" className="me-2" /> Saving...</>
                            ) : (
                              isEditing ? "Update Profile" : "Save Profile"
                            )}
                          </Button>
                        </div>
                      </div>
                      {/* Section 1: Basic Information & Address */}
                      <Card className="mb-3" style={{ border: '2px solid #556ee6', borderRadius: '10px', boxShadow: '0 2px 8px rgba(85,110,230,0.08)', overflow: 'hidden' }}>
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center mb-3 pb-2 border-bottom">
                            <div style={{
                              width: '28px',
                              height: '28px',
                              borderRadius: '5px',
                              backgroundColor: 'rgba(85, 110, 230, 0.1)',
                              color: '#556ee6',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              marginRight: '10px'
                            }}>
                              <User size={16} />
                            </div>
                            <h6 className="mb-0" style={{ fontWeight: 'bold', fontSize: '14px', color: '#556ee6', fontFamily: "'Poppins', sans-serif" }}>Basic Information & Address</h6>
                          </div>
                          <Row>
                            <Col md={2}>
                              <div className="form-group mb-2">
                                <Label className="col-form-label pb-0" htmlFor="customer_Salutation" style={{ fontSize: '12px', fontWeight: '600', color: '#495057', marginBottom: '2px' }}>
                                  Salutation
                                </Label>
                                <Select
                                  id="customer_Salutation"
                                  name="customer_Salutation"
                                  options={[
                                    { value: "Mr.", label: "Mr." },
                                    { value: "Ms.", label: "Ms." },
                                    { value: "Mrs.", label: "Mrs." },
                                    { value: "Dr.", label: "Dr." }
                                  ]}
                                  filterOption={() => true}
                                  value={form.customer_Salutation ? { value: form.customer_Salutation, label: form.customer_Salutation } : null}
                                  onChange={(option) => handleSelectChange('customer_Salutation', option)}
                                  isClearable
                                  isSearchable
                                  placeholder="Mr / Ms / Mrs"
                                  classNamePrefix="select2-selection"
                                  isDisabled={isViewOnly}
                                  styles={{
                                    control: (provided, state) => ({
                                      ...provided,
                                      backgroundColor: '#fff',
                                      borderColor: state.isFocused ? '#556ee6' : '#ced4da',
                                      boxShadow: state.isFocused ? '0 0 0 0.2rem rgba(85, 110, 230, 0.25)' : 'none',
                                      minHeight: '35px',
                                      borderRadius: '5px',
                                      fontSize: '13px'
                                    }),
                                    menu: (provided) => ({
                                      ...provided,
                                      borderRadius: '6px',
                                      zIndex: 9999
                                    }),
                                    option: (provided, state) => ({
                                      ...provided,
                                      backgroundColor: state.isSelected ? '#556ee6' : state.isFocused ? '#f8f9fa' : 'white',
                                      color: state.isSelected ? 'white' : '#495057',
                                      fontSize: '13px'
                                    })
                                  }}
                                />
                              </div>
                            </Col>
                            <Col md={5}>
                              <FormInput
                                label="Customer Name (English)"
                                id="customer_NameEn"
                                name="customer_NameEn"
                                value={form.customer_NameEn}
                                onChange={handleInputChange}
                                required={true}
                                placeholder="Enter customer name in English"
                                error={validationErrors.customer_NameEn}
                                disabled={isViewOnly}
                                icon={User}
                              />
                            </Col>
                            <Col md={5}>
                              <FormInput
                                label="Customer Name (Arabic)"
                                id="customer_NameAr"
                                name="customer_NameAr"
                                value={form.customer_NameAr}
                                onChange={handleInputChange}
                                required={false}
                                placeholder="Enter customer name in Arabic"
                                error={validationErrors.customer_NameAr}
                                disabled={isViewOnly}
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col md={4}>
                              <FormInput
                                label="Email"
                                id="customer_Email"
                                name="customer_Email"
                                type="email"
                                value={form.customer_Email}
                                onChange={handleInputChange}
                                required={false}
                                placeholder="Enter email address"
                                error={validationErrors.customer_Email}
                                disabled={isViewOnly}
                                icon={Mail}
                              />
                            </Col>
                            <Col md={4}>
                              <FormInput
                                label="Contact Number"
                                id="customer_ContactNo"
                                name="customer_ContactNo"
                                type="text"
                                value={form.customer_ContactNo}
                                onChange={handleInputChange}
                                required={true}
                                placeholder="Enter contact number"
                                error={validationErrors.customer_ContactNo}
                                disabled={isViewOnly}
                                icon={Phone}
                              />
                            </Col>
                            <Col md={4}>
                              {form.customer_Type === 1 && (
                                <FormInput
                                  label="Date of Birth"
                                  id="customer_DOB"
                                  name="customer_DOB"
                                  type="date"
                                  value={form.customer_DOB}
                                  onChange={handleInputChange}
                                  required={false}
                                  error={validationErrors.customer_DOB}
                                  disabled={isViewOnly}
                                  icon={Calendar}
                                />
                              )}
                            </Col>
                          </Row>
                          <Row>
                            <Col md={6}>
                              <FormInput
                                label="Address (English)"
                                id="customer_AddressEn"
                                name="customer_AddressEn"
                                value={form.customer_AddressEn}
                                onChange={handleInputChange}
                                required={false}
                                placeholder="Enter address in English"
                                error={validationErrors.customer_AddressEn}
                                disabled={isViewOnly}
                                icon={MapPin}
                              />
                            </Col>
                            <Col md={6}>
                              <FormInput
                                label="Address (Arabic)"
                                id="customer_AddressAr"
                                name="customer_AddressAr"
                                value={form.customer_AddressAr}
                                onChange={handleInputChange}
                                required={false}
                                placeholder="Enter address in Arabic"
                                error={validationErrors.customer_AddressAr}
                                disabled={isViewOnly}
                                icon={MapPin}
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col md={4}>
                              <FormSelect
                                label="Country"
                                id="customer_Country_Id"
                                name="customer_Country_Id"
                                required={true}
                                options={countries.map(country => ({
                                  value: country.country_Id,
                                  label: `${country.country_NameEn} - ${country.country_NameAr}`
                                }))}
                                value={countries.map(country => ({
                                  value: country.country_Id,
                                  label: `${country.country_NameEn} - ${country.country_NameAr}`
                                })).find(option => option.value === form.customer_Country_Id) || null}
                                onChange={(option) => handleSelectChange('customer_Country_Id', option)}
                                error={validationErrors.customer_Country_Id}
                                disabled={isViewOnly}
                                icon={MapPin}
                              />
                            </Col>
                            <Col md={4}>
                              <FormSelect
                                label="Company"
                                id="customer_Business_Id"
                                name="customer_Business_Id"
                                required={true}
                                options={businessOptions}
                                value={businessOptions.find(option => option.value === form.customer_Business_Id) || null}
                                onChange={(option) => handleSelectChange('customer_Business_Id', option)}
                                error={validationErrors.customer_Business_Id}
                                disabled={isViewOnly || !!localStorage.getItem("userCompanyId")}
                                icon={Building2}
                              />
                            </Col>
                            <Col md={4}>
                              <FormSelect
                                label="Branch"
                                id="customer_Branch_Id"
                                name="customer_Branch_Id"
                                options={branches
                                  .filter(b => !form.customer_Business_Id || b.branch_Buisness_Id === form.customer_Business_Id)
                                  .map(branch => ({
                                    value: branch.branch_Id,
                                    label: branch.branch_NameEn
                                  }))}
                                value={branches
                                  .filter(b => !form.customer_Business_Id || b.branch_Buisness_Id === form.customer_Business_Id)
                                  .map(branch => ({
                                    value: branch.branch_Id,
                                    label: branch.branch_NameEn
                                  }))
                                  .find(option => option.value === form.customer_Branch_Id) || null}
                                onChange={(option) => handleSelectChange('customer_Branch_Id', option)}
                                required={true}
                                error={validationErrors.customer_Branch_Id}
                                disabled={isViewOnly || !!localStorage.getItem("userBranchId")}
                                icon={Building2}
                              />
                            </Col>
                          </Row>
                        </CardBody>
                      </Card>

                      {/* Section 2: Identification, Compliance & Finance */}
                      <Card className="mb-3" style={{ border: '2px solid #28a745', borderRadius: '10px', boxShadow: '0 2px 8px rgba(40,167,69,0.08)', overflow: 'hidden' }}>
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center mb-3 pb-2 border-bottom">
                            <div style={{
                              width: '28px',
                              height: '28px',
                              borderRadius: '5px',
                              backgroundColor: 'rgba(40, 167, 69, 0.1)',
                              color: '#28a745',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              marginRight: '10px'
                            }}>
                              <CreditCard size={16} />
                            </div>
                            <h6 className="mb-0" style={{ fontWeight: 'bold', fontSize: '14px', color: '#28a745', fontFamily: "'Poppins', sans-serif" }}>Identification, Compliance & Finance</h6>
                          </div>
                          {form.customer_Type === 2 && (
                            <Row className="mb-2">
                              <Col md={12}>
                                <FormInput
                                  label="Company Name"
                                  id="company_Name"
                                  name="company_Name"
                                  value={form.company_Name}
                                  onChange={handleInputChange}
                                  required={false}
                                  placeholder="Enter company name"
                                  error={validationErrors.company_Name}
                                  disabled={isViewOnly}
                                  icon={Building2}
                                />
                              </Col>
                            </Row>
                          )}
                          <Row>
                            <Col md={4}>
                              <FormInput
                                label="TRN (Tax Registration Number)"
                                id="customer_TRN"
                                name="customer_TRN"
                                value={form.customer_TRN}
                                onChange={handleInputChange}
                                required={false}
                                placeholder="Enter TRN"
                                error={validationErrors.customer_TRN}
                                disabled={isViewOnly}
                                icon={FileText}
                              />
                            </Col>
                            <Col md={4}>
                              <FormInput
                                label={form.customer_Type === 1 ? "National ID Number" : "Business ID Number"}
                                id="customer_ID_Number"
                                name="customer_ID_Number"
                                value={form.customer_ID_Number}
                                onChange={handleInputChange}
                                required={false}
                                placeholder={form.customer_Type === 1 ? "Enter national ID number" : "Enter business ID number"}
                                error={validationErrors.customer_ID_Number}
                                disabled={isViewOnly}
                                icon={FileText}
                              />
                            </Col>
                            <Col md={4}>
                              <FormInput
                                label="Credit Limit"
                                id="customer_CreditLimit"
                                name="customer_CreditLimit"
                                type="number"
                                value={form.customer_CreditLimit}
                                onChange={handleInputChange}
                                required={false}
                                placeholder="Enter credit limit"
                                error={validationErrors.customer_CreditLimit}
                                disabled={isViewOnly}
                                icon={CreditCard}
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col md={4}>
                              <FormInput
                                label="Initial Loyalty Points"
                                id="initialPoints"
                                name="initialPoints"
                                type="number"
                                value={form.initialPoints}
                                onChange={handleInputChange}
                                required={false}
                                placeholder="Enter initial points"
                                error={validationErrors.initialPoints}
                                disabled={isViewOnly}
                                icon={FileText}
                              />
                            </Col>
                            <Col md={4}>
                              <FormInput
                                label="Primary Contact Name"
                                id="primaryContact_Name"
                                name="primaryContact_Name"
                                value={form.primaryContact_Name}
                                onChange={handleInputChange}
                                required={false}
                                placeholder="Enter primary contact name"
                                error={validationErrors.primaryContact_Name}
                                disabled={isViewOnly}
                                icon={User}
                              />
                            </Col>
                            <Col md={4}>
                              <FormInput
                                label="Primary Contact Phone"
                                id="primaryContact_Phone"
                                name="primaryContact_Phone"
                                type="number"
                                value={form.primaryContact_Phone}
                                onChange={handleInputChange}
                                required={false}
                                placeholder="Enter primary contact phone"
                                error={validationErrors.primaryContact_Phone}
                                disabled={isViewOnly}
                                icon={Phone}
                              />
                            </Col>
                          </Row>
                          {form.customer_Type === 2 && (
                            <Row>
                              <Col md={12}>
                                <FormTextarea
                                  label="Customer Representative Details"
                                  id="customer_RepDetails"
                                  name="customer_RepDetails"
                                  value={form.customer_RepDetails}
                                  onChange={handleInputChange}
                                  required={false}
                                  placeholder="Enter customer representative details"
                                  rows={3}
                                />
                              </Col>
                            </Row>
                          )}
                          <Row>
                            <Col md={12}>
                              <FormTextarea
                                label="Notes"
                                id="customer_Notes"
                                name="customer_Notes"
                                value={form.customer_Notes}
                                onChange={handleInputChange}
                                required={false}
                                placeholder="Enter additional notes"
                                rows={3}
                                icon={FileText}
                              />
                            </Col>
                          </Row>
                          <Row className="align-items-start mt-3 pt-3 border-top">
                            <Col md={4}>
                              <FormRadio
                                label="Customer Type"
                                name="customer_Type"
                                options={[
                                  { value: 1, label: "Individual" },
                                  { value: 2, label: "Business" }
                                ]}
                                value={form.customer_Type}
                                onChange={handleInputChange}
                                required={true}
                              />
                            </Col>
                            <Col md={3} className="pt-4 mt-1">
                              <FormCheckbox
                                label="International"
                                id="customer_IsInternational"
                                name="customer_IsInternational"
                                checked={form.customer_IsInternational}
                                onChange={handleInputChange}
                              />
                            </Col>
                            <Col md={3} className="pt-4 mt-1">
                              {hasDeletePermission && (
                                <FormCheckbox
                                  label="Active"
                                  id="customer_Active"
                                  name="customer_Active"
                                  checked={form.customer_Active}
                                  onChange={handleInputChange}
                                />
                              )}
                            </Col>
                          </Row>
                        </CardBody>
                      </Card>
                    </Form>
                  </div>

                  {/* Excel Import Section */}
                  {!isViewOnly && showExcelImport && (
                    <div id="excelImportSection" className="mt-3">
                      <Card style={{ border: '2px solid #17a2b8', borderRadius: '10px', boxShadow: '0 2px 8px rgba(23,162,184,0.08)', overflow: 'hidden' }}>
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center mb-3 pb-2 border-bottom">
                            <div style={{
                              width: '28px',
                              height: '28px',
                              borderRadius: '5px',
                              backgroundColor: 'rgba(23, 162, 184, 0.1)',
                              color: '#17a2b8',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              marginRight: '10px'
                            }}>
                              <Download size={16} />
                            </div>
                            <h6 className="mb-0" style={{ fontWeight: 'bold', fontSize: '14px', color: '#17a2b8', fontFamily: "'Poppins', sans-serif" }}>Bulk Excel Import</h6>
                          </div>

                          <div className="mb-4">
                            <Label for="excelFile" className="form-label" style={{ fontSize: '12px', fontWeight: '600', color: '#495057', marginBottom: '4px' }}>
                              Select Excel File (.xlsx or .xls)
                            </Label>
                            <div className="d-flex gap-3 align-items-center">
                              <Input
                                type="file"
                                id="excelFile"
                                accept=".xlsx,.xls"
                                onChange={handleFileUpload}
                                className="form-control"
                                style={{ borderRadius: '6px' }}
                              />
                            </div>
                            <small className="form-text text-muted mt-2 d-block">
                              <Info size={14} className="me-1" />
                              Excel file should contain columns: <b>First Name, Last Name, Phone/MobilePhone, Salutation</b>
                            </small>
                          </div>

                          {parsedData.length > 0 && (
                            <div className="mb-4">
                              <h6 className="mb-3">Data Preview ({parsedData.length} customers found):</h6>
                              <div className="table-responsive" style={{ maxHeight: '300px', overflowY: 'auto', borderRadius: '8px', border: '1px solid #dee2e6' }}>
                                <Table className="table table-hover table-striped mb-0">
                                  <thead style={{ backgroundColor: '#f8f9fa', position: 'sticky', top: 0, zIndex: 1 }}>
                                    <tr>
                                      <th className="border-0">#</th>
                                      <th className="border-0">Name</th>
                                      <th className="border-0">Phone</th>
                                      <th className="border-0">Salutation</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {parsedData.slice(0, 10).map((customer, index) => (
                                      <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{customer.customer_NameEn}</td>
                                        <td>{customer.customer_ContactNo}</td>
                                        <td>{customer.customer_Salutation}</td>
                                      </tr>
                                    ))}
                                    {parsedData.length > 10 && (
                                      <tr>
                                        <td colSpan="4" className="text-center text-muted py-2 bg-light">
                                          ... and {parsedData.length - 10} more records ...
                                        </td>
                                      </tr>
                                    )}
                                  </tbody>
                                </Table>
                              </div>
                            </div>
                          )}

                          <div className="d-flex gap-2 justify-content-end align-items-center mt-3">
                            {importLoading && (
                               <div className="d-flex align-items-center me-3 text-info">
                                 <ClipLoader size={16} color="#17a2b8" className="me-2" />
                                 <span style={{ fontWeight: '500' }}>Processing...</span>
                               </div>
                            )}
                            <Button
                              color="secondary"
                              outline
                              onClick={() => {
                                setParsedData([]);
                                setExcelFile(null);
                                const fileInput = document.getElementById('excelFile');
                                if (fileInput) fileInput.value = '';
                              }}
                              disabled={importLoading || parsedData.length === 0}
                              style={{ borderRadius: '6px' }}
                            >
                              Clear Data
                            </Button>
                            <Button
                              color="info"
                              onClick={handleBulkImport}
                              disabled={importLoading || parsedData.length === 0}
                              style={{ borderRadius: '6px', minWidth: '150px' }}
                            >
                              {importLoading ? (
                                'Importing...'
                              ) : (
                                <><Download size={16} className="me-2" /> Complete Import</>
                              )}
                            </Button>
                          </div>
                        </CardBody>
                      </Card>
                    </div>
                  ) }
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Customer Profile Modal */}
      <CustomerProfileModal
        isOpen={profileModalOpen}
        toggle={() => setProfileModalOpen(false)}
        customer={selectedCustomer}
        customerId={selectedCustomer?.customer_Id || null}
      />
    </React.Fragment>
  );
}
